export default __webpack_public_path__ + "static/media/monitor_400.2c51f0d5.gif";